import { useEffect, useMemo, useRef } from 'react';

import type { IBreadcrumbItem } from '@/DesignSystem/Model/DataModel';
import { LINKS } from '@/Module/Core/Constant';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
import { getLessonByTeacherIdAction } from '@/Module/Teacher/Store/Action/getLessonByTeacherIdAction';
import { selectedTeacherSelector } from '@/Module/Teacher/Store/Selector/selectedTeacherSelector';

export const useTeacherDetailPage = () => {
  const dispatch = useAppDispatch();
  const isInitialed = useRef(false);

  const teacher = useAppSelector(selectedTeacherSelector);
  const teacherTitle = `${teacher?.person?.name ?? ''}  ${teacher?.person?.family ?? ''}`;
  const page = useAppSelector(state => state.lessonTeacher.page);

  const breadcrumb: IBreadcrumbItem[] = useMemo(() => {
    return [
      {
        key: 'TEACHER_LIST',
        title: 'معلم‌ها',
        href: LINKS.TEACHER_LIST,
      },
      {
        key: 'TEACHER',
        title: teacherTitle,
      },
    ];
  }, [teacherTitle]);

  useEffect(() => {
    if (!teacher?.id || !isInitialed.current) {
      isInitialed.current = true;
      return () => {};
    }

    const promise = dispatch(getLessonByTeacherIdAction(teacher.id));

    return () => {
      promise.abort();
    };
  }, [page, teacher?.id]);

  return {
    teacher,
    teacherTitle,
    breadcrumb,
  };
};
